/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The JobTagLink model module.
 * @module model/JobTagLink
 * @version V1
 */
class JobTagLink {
    /**
     * Constructs a new <code>JobTagLink</code>.
     * @alias module:model/JobTagLink
     */
    constructor() { 
        
        JobTagLink.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>JobTagLink</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/JobTagLink} obj Optional instance to populate.
     * @return {module:model/JobTagLink} The populated <code>JobTagLink</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new JobTagLink();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('accountId')) {
                obj['accountId'] = ApiClient.convertToType(data['accountId'], 'Number');
            }
            if (data.hasOwnProperty('jobId')) {
                obj['jobId'] = ApiClient.convertToType(data['jobId'], 'Number');
            }
            if (data.hasOwnProperty('tags')) {
                obj['tags'] = ApiClient.convertToType(data['tags'], 'String');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>JobTagLink</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>JobTagLink</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['tags'] && !(typeof data['tags'] === 'string' || data['tags'] instanceof String)) {
            throw new Error("Expected the field `tags` to be a primitive type in the JSON string but got " + data['tags']);
        }

        return true;
    }


}



/**
 * @member {Number} id
 */
JobTagLink.prototype['id'] = undefined;

/**
 * @member {Number} accountId
 */
JobTagLink.prototype['accountId'] = undefined;

/**
 * @member {Number} jobId
 */
JobTagLink.prototype['jobId'] = undefined;

/**
 * @member {String} tags
 */
JobTagLink.prototype['tags'] = undefined;

/**
 * @member {Date} createdAt
 */
JobTagLink.prototype['createdAt'] = undefined;






export default JobTagLink;

